import { z } from 'zod';
import { atonePaymentSchema } from '@schemas/common-schemas/atone-common-schema';
import { allowEmpty, mandatoryStr, str } from '@schemas/common-schemas/schema-utils';

/**
 * atoneつど後払い決済サービスのサービス分類子の実際のチェック項目。
 *
 * これを持ってして、どのサービスのパラメータかをまず判別する。
 */
const atoneLiteSettlementServiceRawParameterClassifierSchema = z.object({
  service_type: z.literal('04'),
  modal_mode: z.literal('01').optional(),
});

/**
 * コールバック以外のServiceパラメータのバリデータ。
 */
export const atoneLiteSettlementServiceParameterValidator = z
  .object({
    pub_key: mandatoryStr,
    ...atoneLiteSettlementServiceRawParameterClassifierSchema.shape,
    pre_token: allowEmpty(str),
    terminal_id: allowEmpty(str),
    payment: atonePaymentSchema,
    request_id: allowEmpty(str),
  })
  .passthrough();

export type AtoneLiteSettlementServiceInputType = typeof atoneLiteSettlementServiceParameterValidator._input;

/**
 * atoneつど後払い決済サービスのサービス分類子。
 *
 * これを持ってして、どのサービスのパラメータかをまず判別する。
 * チェック項目以外の全パラメータの型情報を付与も附与されている。
 *
 * クライアント -> ModalDriverに対する入力は、コレを利用してサービスの分類の正しさのみ検証する。
 */
export const atoneLiteSettlementServiceParameterClassifierSchema =
  atoneLiteSettlementServiceRawParameterClassifierSchema as unknown as typeof atoneLiteSettlementServiceParameterValidator;
